import { Routes } from '@angular/router';

export const waybillRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./waybills-table/waybills-table.component').then((m) => m.WaybillsTableComponent),
  },
];
